// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"051013fa","239":"ff4c4d75","453":"23b4945d","455":"ece680ce","762":"c61fd293"}[chunkId] + ".chunk.js";
};